import {
    ArrayInput,
    CheckboxGroupInput,
    Create,
    CreateProps,
    FormDataConsumer,
    NumberInput,
    RadioButtonGroupInput,
    ReferenceArrayInput,
    SimpleFormIterator,
    TextInput,
    maxValue,
    minValue,
    required,
} from 'react-admin';
import {
    CSSTransitionProps,
} from 'react-transition-group/CSSTransition';
import {
    CompactForm,
    RaGrid,
} from 'ra-compact-ui';
import { dayOrNightChoices } from '../types';

export const ContractorCreate = (props: CreateProps) => {
    const transitionProps: CSSTransitionProps = {
        classNames: "",
        addEndListener: () => undefined,
    };
    return (
        <Create {...props}>
            <CompactForm layoutComponents={[RaGrid]} redirect="show">
                <RaGrid container spacing={2}>
                    <RaGrid item xs={12}>
                        <TextInput source="name" label="名前" validate={[required()]} fullWidth />
                    </RaGrid>
                    <RaGrid item xs={12}>
                        <ReferenceArrayInput source="contractorCategoryIds" label="業種" reference="contractorCategories" validate={[required()]} fullWidth>
                            <CheckboxGroupInput />
                        </ReferenceArrayInput>
                    </RaGrid>
                    <RaGrid item xs={12}>
                        <ArrayInput source="workUnits" label="工事項目" initialValue={[{}]}>
                            <SimpleFormIterator TransitionProps={transitionProps}>
                                <FormDataConsumer fullWidth>
                                    {({ getSource }) => {
                                        return getSource ? (
                                            <RaGrid container spacing={2}>
                                                <RaGrid item xs={2}>
                                                    <RadioButtonGroupInput source={getSource('dayOrNight')} label="" validate={[required()]} choices={dayOrNightChoices} fullWidth />
                                                </RaGrid>
                                                <RaGrid item xs={6}>
                                                    <TextInput source={getSource('name')} label="名前" validate={[required()]} fullWidth />
                                                </RaGrid>
                                                <RaGrid item xs={4}>
                                                    <NumberInput source={getSource('unitPrice')} label="単価" validate={[required(), minValue(0), maxValue(Number.MAX_SAFE_INTEGER)]} fullWidth />
                                                </RaGrid>
                                            </RaGrid>
                                        ) : null;
                                    }}
                                </FormDataConsumer>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </RaGrid>
                </RaGrid>
            </CompactForm>
        </Create>
    );
};
